module.exports = __webpack_public_path__ + "static/media/star.8536942f.png";